import { getProductsSelfData } from '../services/growth';

const productsSelfDataQuery = {
  key: 'productsSelfData',
  query: getProductsSelfData,
};

export { productsSelfDataQuery };
